import React, { useEffect, useState } from 'react';
import OTPInput from 'react-otp-input';

const RESEND_OTP_COOLDOWN_SECONDS = 120;

const OtpView = ({...props}) => {
    const [resendCooldown, setResendCooldown] = useState(RESEND_OTP_COOLDOWN_SECONDS);

    useEffect(() => {
        if (resendCooldown <= 0) return undefined;

        const timer = setTimeout(() => {
            setResendCooldown((prev) => Math.max(prev - 1, 0));
        }, 1000);

        return () => clearTimeout(timer);
    }, [resendCooldown]);

    const handleResendOtp = () => {
        props.ReSendOtp();
        setResendCooldown(RESEND_OTP_COOLDOWN_SECONDS);
    };

    const isResendDisabled = resendCooldown > 0;
    const resendText = isResendDisabled
        ? `You can resend the One Time Password in ${resendCooldown} seconds.`
        : 'Not received the One Time Password?';

    return (
        <>
            <div className="field">
                <label for="txtCurrentPassword">Enter OTP code sent to </label>
                <h5>{props?.EmailOrPhone}</h5>
                {/* {!!props?.optionalField && <h5>and {props?.optionalField}</h5>} */}
            </div>
            <div className="field">
                <label for="txtCurrentPassword">Enter Your OTP</label>
                <div className="changePass-grid enter-otp-block">
                    <OTPInput
                        value={props?.otp}
                        onChange={(value) => props?.handleSetOtp(value)}
                        numInputs={6}
                        className="customotp"
                        renderInput={(props) => (
                            <input
                                {...props}
                                placeholder=""
                                type="number"
                            // onKeyUp={e => {
                            //     if (e.key === 'Enter' && state.otp.length == 6) {
                            //         handleOTPVerification()
                            //     }
                            // }}
                            />
                        )}
                    />
                </div>
                {props?.otpErr && <span>{props?.otpErr}</span>}
            </div>
            <p>{resendText}</p> <button onClick={handleResendOtp} className="cta-green" disabled={isResendDisabled}>Resend OTP</button>
        </>
    )
}
export default OtpView
